const AVAIBLE_FLAGS = {
    AS_TRADED: 'AS_TRADED',
    CERTIFIED: 'CERTIFIED',
    EXTENDED_WARANTY: 'EXTENDED_WARANTY',
    INSPECTED: 'INSPECTED',
};

export default AVAIBLE_FLAGS;
